import { usePumpSizing } from "../../../context/PumpSizingContext";
import { Button } from "../../shared/Button";

export function SaveResultsButton() {
	const {
		saveResults,
		isSavingResults,
		chartData,
		isResultsLoading,
		savedSubmissionUuid,
	} = usePumpSizing();

	return (
		<Button
			onClick={saveResults}
			disabled={isSavingResults || isResultsLoading || chartData === null}
		>
			<span>
				{isSavingResults
					? "Saving…"
					: savedSubmissionUuid
						? "Update Results"
						: "Save Results"}
			</span>
		</Button>
	);
}
